import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import {
  initialPaymentDetails,
  initialPaymentDetailsState,
  initialPaymentOverview,
} from "./defaultState";
import {
  CLEAR_PAYMENT_DETAIL_STATE,
  FETCH_LEAD_PAYMENT_DETAILS_LIST_FAILED,
  FETCH_LEAD_PAYMENT_DETAILS_LIST_PROGRESS,
  FETCH_LEAD_PAYMENT_DETAILS_LIST_SUCCESS,
  FETCH_PAST_PAYMENT_STATUS_COUNT_FAILED,
  FETCH_PAST_PAYMENT_STATUS_COUNT_PROGRESS,
  FETCH_PAST_PAYMENT_STATUS_COUNT_SUCCESS,
  FETCH_PAYMENT_DETAIL_FAILED,
  FETCH_PAYMENT_DETAIL_PROGRESS,
  FETCH_PAYMENT_DETAIL_SUCCESS,
  FETCH_PAYMENT_DETAILS_LIST_FAILED,
  FETCH_PAYMENT_DETAILS_LIST_PROGRESS,
  FETCH_PAYMENT_DETAILS_LIST_SUCCESS,
  FETCH_PAYMENT_LIST_STATUS_COUNT_FAILED,
  FETCH_PAYMENT_LIST_STATUS_COUNT_PROGRESS,
  FETCH_PAYMENT_LIST_STATUS_COUNT_SUCCESS,
  FETCH_PAYMENT_STATUS_COUNT_FAILED,
  FETCH_PAYMENT_STATUS_COUNT_PROGRESS,
  FETCH_PAYMENT_STATUS_COUNT_SUCCESS,
} from "./paymentDetailsActions";
import { PaymentDetailsActions } from ".";
import { CLEAR_LEAD_STATE } from "../leads/leadsActions";
import { initialLeadState } from "../leads/leads.types";

export const paymentDetailsReducer = (
  state: IStoreState["payment_details"] = initialPaymentDetailsState,
  action: PaymentDetailsActions
) => {
  switch (action.type) {
    case FETCH_PAYMENT_DETAILS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.Payment_list.loading = LoadState.InProgress;
        draftState.Payment_list.list = [];
        draftState.Payment_list.error = null;
      });
      return newState;
    }

    case FETCH_PAYMENT_DETAILS_LIST_SUCCESS: {
      const { Payment_list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.Payment_list.loading = LoadState.Loaded;
        draftState.Payment_list.list = Payment_list;

        draftState.Payment_list.error = null;
      });
      return newState;
    }

    case FETCH_PAYMENT_DETAILS_LIST_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.Payment_list.loading = LoadState.Failed;
        draftState.Payment_list.list = [];

        draftState.list.error = errorMessage; // Store error message
      });
      return newState;
    }

    case FETCH_PAYMENT_DETAIL_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.data.loading = LoadState.InProgress;
        draftState.data.data = initialPaymentDetails;
        draftState.data.error = null;
      });
      return newState;
    }

    case FETCH_PAYMENT_DETAIL_SUCCESS: {
      const { paymentDetail } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.data.loading = LoadState.Loaded;
        draftState.data.data = paymentDetail;
        draftState.data.error = null;
      });
      return newState;
    }

    case FETCH_PAYMENT_DETAIL_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.data.loading = LoadState.Failed;
        draftState.data.error = errorMessage;
      });
      return newState;
    }

    case FETCH_LEAD_PAYMENT_DETAILS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.error = null;
      });
      return newState;
    }

    case FETCH_LEAD_PAYMENT_DETAILS_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = list;
        draftState.list.error = null;
      });
      return newState;
    }

    case FETCH_LEAD_PAYMENT_DETAILS_LIST_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = errorMessage;
      });
      return newState;
    }

    case CLEAR_PAYMENT_DETAIL_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.data.loading = LoadState.NotLoaded;
        draftState.data.data = initialPaymentDetails;
        draftState.data.error = null;
      });
      return newState;
    }

    case FETCH_PAYMENT_STATUS_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.InProgress;
        draftState.recordCounts.list = [];
      });
      return newState;
    }
    case FETCH_PAYMENT_STATUS_COUNT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Loaded;
        draftState.recordCounts.list = data;
      });
      return newState;
    }
    case FETCH_PAYMENT_STATUS_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Failed;
        draftState.recordCounts.list = [];
      });
      return newState;
    }

    case FETCH_PAYMENT_LIST_STATUS_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.paymentList.loading = LoadState.InProgress;
        draftState.paymentList.list = [];
        draftState.paymentList.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PAYMENT_LIST_STATUS_COUNT_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.paymentList.loading = LoadState.Loaded;
        draftState.paymentList.list = list;
        draftState.paymentList.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PAYMENT_LIST_STATUS_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.paymentList.loading = LoadState.InProgress;
        draftState.paymentList.list = [];
        draftState.paymentList.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PAST_PAYMENT_STATUS_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.pastPaymentStatusCounts.loading = LoadState.InProgress;
        draftState.pastPaymentStatusCounts.list = [];
      });
      return newState;
    }
    case FETCH_PAST_PAYMENT_STATUS_COUNT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.pastPaymentStatusCounts.loading = LoadState.Loaded;
        draftState.pastPaymentStatusCounts.list = data;
      });
      return newState;
    }
    case FETCH_PAST_PAYMENT_STATUS_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.pastPaymentStatusCounts.loading = LoadState.Failed;
        draftState.pastPaymentStatusCounts.list = [];
      });
      return newState;
    }

    case CLEAR_PAYMENT_DETAIL_STATE: {
      return initialPaymentDetailsState;
    }

    default: {
      return state;
    }
  }
};
